import { styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  color: theme.palette.success.contrastText
}));

export default CloseIconStyled;
